export default __webpack_public_path__ + "static/media/EditActionButton.8ecbf5f9.svg";